e4.p.banner = {
    init: function () {
        e4.p.banner.events = e4.util.registerEvents('animatein animateout', 'banner');
        e4.p.banner.loadImages();
        e4.p.banner.bindEvents();
    },
    loadImages: function () {
        jQuery( '.js-p-banner-animation-image' ).each( function () {
            if(jQuery( this ).is('.js-banner-image-lazyloading') === false){
                jQuery( this ).css( 'background-image', 'url(' + this.getAttribute( 'data-src' ) + ')' ); 
            }
        } );
        var firstBannerElement = jQuery( '.js-p-banner-animation-image' ).filter( ':first-child' );
        firstBannerElement.addClass( 'animate-in' );
        jQuery( document ).trigger('animatein.e4.banner', [firstBannerElement.get(0)]);
        
    },
    bindEvents: function () {
        jQuery( '.js-p-banner-animation-image-container' ).on( e4.settings.event.animationend, '.js-p-banner-animation-image', function () {
            e4.p.banner.animate( this );
        } ).on( e4.settings.event.transitionend, '.js-p-banner-animation-image.animate-out', function () {
            jQuery( document ).trigger('animateout.e4.banner');
            jQuery( this ).removeClass( 'animate-out' );
        } );
        jQuery( '.js-p-banner-next-section-link' ).on( 'click', function ( event ) {
            event.preventDefault();
            e4.p.banner.scrollToNextSection( this );
        } );
    },
    scrollToNextSection: function ( domElm ) {
        var intNextSectionOffset = jQuery( domElm ).closest( '.e-section' ).next( '.e-section' ).offset().top;
        e4.scrollToAnchor.animate( intNextSectionOffset );
    },
    animate: function ( domElm ) {
        var jImageActive = jQuery( domElm ),
            jImageNext = jImageActive.next();
        if ( jImageNext.length === 0 ) {
            jImageNext = jImageActive.closest( '.js-p-banner-animation-image-container' ).find( '.js-p-banner-animation-image' ).first();
        }
        jQuery( document ).trigger('animatein.e4.banner', [jImageNext.get(0)]);
        jImageNext.addClass( 'animate-in' );
        jImageActive.removeClass( 'animate-in' ).addClass( 'animate-out' );
        
    }
};

